import { cn } from "@/lib/utils";
import { Icon } from "@tabler/icons-react";
import { IconType } from "react-icons";
import { LuCircleCheck } from "react-icons/lu";
import { LuTriangleAlert } from "react-icons/lu";

export interface ToastContentProps {
  icon?: IconType | Icon;
  iconProps?: {
    size?: number;
    strokeWidth?: number;
    className?: string;
  };
  headingPrefix?: string;
  headingHighlight?: string;
  headingSuffix?: string;
  subheadingPrefix?: string;
  subheadingHighlight?: string;
  subheadingSuffix?: string;
  isError?: boolean;
  isWarning?: boolean;
}

const ToastContent = ({
  icon: Icon,
  iconProps = {
    size: 16,
    strokeWidth: 2,
  },
  headingPrefix = "",
  headingHighlight = "",
  headingSuffix = "",
  subheadingPrefix = "",
  subheadingHighlight = "",
  subheadingSuffix = "",
  isError = false,
  isWarning = false,
}: ToastContentProps) => {
  return (
    <div className="flex items-start gap-2 bg-white">
      <div>
        {Icon ? (
          <Icon
            {...iconProps}
            className={cn(
              iconProps.className,
              isError
                ? "text-error-default"
                : isWarning
                  ? "text-[#FA8E01]"
                  : "text-brand-blue",
            )}
          />
        ) : isError ? (
          <LuTriangleAlert
            {...iconProps}
            className={cn(
              iconProps.className,
              isWarning ? "text-[#FA8E01]" : "text-error-default",
            )}
          />
        ) : (
          <LuCircleCheck
            {...iconProps}
            className={cn(
              iconProps.className,
              isWarning ? "text-[#FA8E01]" : "text-brand-blue",
            )}
          />
        )}
      </div>
      <div className="flex flex-col gap-1">
        <div
          className={cn(
            "text-[14px] font-normal leading-[16px] tracking-[-0.35px]",
            isError
              ? "text-error-default"
              : isWarning
                ? "text-[#FA8E01]"
                : "text-brand-blue",
          )}
        >
          {headingPrefix}{" "}
          {headingHighlight && <span className="font-[500]">{headingHighlight}</span>}{" "}
          {headingSuffix}
        </div>
        <div className="text-brand-primary-new text-xs font-normal">
          {subheadingPrefix}{" "}
          {subheadingHighlight && (
            <span className="font-[500] leading-[20px]">{subheadingHighlight}</span>
          )}{" "}
          {subheadingSuffix}
        </div>
      </div>
    </div>
  );
};

export default ToastContent;
